import IconButton from '@mui/material/IconButton';
import {styled as muiStyled} from '@mui/material/styles';

const ChatbotTopbarIconButton = muiStyled(IconButton)(() => ({
  width: 28,
  height: 28
}));

export default ChatbotTopbarIconButton;
